import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Users|Email History|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Core,
	portal: 'SP',
};

type LocNameStart = 'SPUserEmailHistory';
export type SPUserEmailHistoryLocNames = `${LocNameStart}TitlePage` | `${LocNameStart}TitleTab`;

export const spUserEmailHistoryLocs: LocDefs<SPUserEmailHistoryLocNames> = {
	SPUserEmailHistoryTitlePage: {
		defaultValue: 'User Email History',
		description: 'Page title.',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Core/Users.EmailHistory.Title.PageTitle',
		...sharedProperties,
	},
	SPUserEmailHistoryTitleTab: {
		defaultValue: 'User Email History',
		description: 'Tab title.',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Core/Users.EmailHistory.Title.TabTitle',
		...sharedProperties,
	},
};

export type SPUserEmailHistoryLocType = LocMap<SPUserEmailHistoryLocNames>;
